module.exports = __webpack_public_path__ + "img/Comoros.93adc43b.svg";